<template>
  <div class="learning">
    <div class="wrap learning-main">
      <el-card>
        <div class="user-info">
          <el-avatar class="user-avatar" src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"
            :size="72"></el-avatar>
          <div class="user-desc-company">
            <div class="user-desc">
              <div class="user-desc">
                <el-tooltip class="item" effect="dark" content="晚上好，系统管理员，用热爱的心态去对待每一个人，尊重他人的感受和需求。"
                  placement="top-start">
                  <div>晚上好，系统管理员，用热爱的心态去对待每一个人，尊重他人的感受和需求。</div>
                </el-tooltip>

              </div>
              <div class="user-company">
                <span>职业培训学校有限公司</span>
              </div>
            </div>
          </div>
        </div>
        <div class="learning-info">
          <div class="class-hour learning-info-item">
            <span>累计完成学时</span>
            <div>0.00</div>
          </div>
          <div class="credit learning-info-item">
            <span>总学时</span>
            <div>120</div>
          </div>
        </div>
      </el-card>
    </div>


  </div>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "learning",
  data() {
    return {}
  },
  methods: {}
}
</script>


<style lang="scss" scoped>
.learning {
  margin: 22px 0;

  .learning-main {
    width: 100%;

  }

  .user-info {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0 20px;

    .user-avatar {
      cursor: pointer;
    }

    .user-desc-company {
      margin-left: 24px;

      .user-desc {
        margin-bottom: 10px;
        font-size: 20px;
        cursor: default;
      }

      .user-company {
        font-size: 14px;
        color: #777;
      }
    }
  }

  .learning-info {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-top: 20px;

    .learning-info-item {
      position: relative;
      padding: 0 130px;
      text-align: center;
      color: #000;
      font-size: 30px;
      cursor: pointer;

      span {

        font-size: 13px;
        color: #888;
      }

      div {
        margin-top: 8px;
      }
    }

    .learning-info-item::after {
      content: "";
      position: absolute;
      right: 0;
      top: 50%;
      width: 1px;
      height: 55%;
      background-color: #eef1f6;
      transform: translateY(-50%);
    }

    .learning-info-item:last-child::after {
      display: none;
    }
  }
}
</style>
